import api from '../api/axios';

export interface RoleModuleAccess {
  id: number;
  roleId: number;
  roleName: string;
  moduleId: string;
  moduleName: string;
  isEnabled: boolean;
}

const RoleModuleAccessService = {
  // Get modules for a specific role
  getByRole: (roleId: number) => 
    api.get(`/role-module-accesses/role/${roleId}`),
  
  // Set modules for a role (bulk update)
  setRoleModules: (roleId: number, moduleIds: string[]) => 
    api.post(`/role-module-accesses/role/${roleId}`, { moduleIds }),
  
  // Get roles that have access to a module
  getByModule: (moduleId: string) => 
    api.get(`/role-module-accesses/module/${moduleId}`),
  
  // Get all role-module access records
  getAll: () => 
    api.get('/role-module-accesses'),
};

export default RoleModuleAccessService;

